export enum ActionType {    
    CALLED = 0,
    LEFT_VOICEMAIL = 1,
    EMAILED = 2,
    TEXTED = 3,
    OTHER = 99
}